import { PageLink } from "components/App/utils";
import { userGuestLogin } from "components/utils";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

export type GuestLoginStatus = "idle" | "inProgress" | "expired";

/** Guest access link from email: /customerGuestLogin/{customerNumber}/{authCode}?pageNumber=... */
export const getGuestLinkParams = (link: string | undefined | null) => {
    if (!link || !link.startsWith(PageLink.CustomerGuestLogin)) {
        return { customerNumber: null, authCode: null };
    }

    const pathParts = link.split("?")[0].split("/");
    return { customerNumber: pathParts[2] || null, authCode: pathParts[3] || null };
};

export const getReferrerPageNumber = (referrer: string | undefined | null): string | null => {
    const search = referrer?.split("?")[1];
    if (!search) {
        return null;
    }

    const urlParams = new URLSearchParams(`?${search}`);
    return urlParams.get("pagenumber") ?? urlParams.get("pageNumber");
};

export const useGuestLogin = (customerNumber: string | null, authCode: string | null): GuestLoginStatus => {
    const history = useHistory();
    const location = useLocation();
    const [status, setStatus] = useState<GuestLoginStatus>(customerNumber && authCode ? "inProgress" : "idle");
    const started = useRef(false);

    useEffect(() => {
        // The auth code is one-time use - the ref guards against a second exchange attempt (e.g. StrictMode re-running the effect)
        if (!customerNumber || !authCode || started.current) {
            return;
        }
        started.current = true;

        userGuestLogin(customerNumber, authCode)
            .then(() => {
                const pageNumber = getReferrerPageNumber(location.search);
                if (pageNumber) {
                    history.replace(`${PageLink.Application}?pageNumber=${pageNumber}`);
                } else {
                    history.replace(PageLink.CustomerHome);
                }
            })
            .catch(() => {
                setStatus("expired");
            });
    }, [customerNumber, authCode, history, location]);

    return status;
};
